import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  addRemoveContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: "8px",
    padding: "8px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "4px",
    },
  },

  dropProbabilities: {
    marginLeft: "8px",
    display: "flex",
    flexFlow: "row wrap",
    gap: "12px",
    alignItems: "flex-end",
    padding: "12px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e0e4e7",
    marginBottom: "8px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "8px",
      marginLeft: "0",
    },
  },

  smallField: {
    width: "140px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  hide: {
    display: "none !important",
  },

  namedPlayerDetailsContainer: {
    display: "flex",
    flexFlow: "row wrap",
    gap: "12px",
    padding: "12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e0e4e7",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: "8px",
    },
  },

  additionalDataContainer: {
    height: "40px",
    minWidth: "140px",
    padding: "0 12px",
    borderRadius: "6px",
    border: "1px solid #d0d7de",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },

  additionDetailsLabel: {
    fontSize: "13px",
    color: "#656d76",
    marginBottom: "4px",
    fontWeight: "500",
  },

  additionDetailsText: {
    fontSize: "14px",
    color: theme.palette.primary.main,
    fontWeight: "500",
  },
}));

export default useStyles;
